import { create } from 'zustand';

/**
 * Globale store voor de offerte-detail drawer. Mirror van
 * order-detail-drawer-store. Geen URL-sync; direct-link naar een offerte
 * blijft werken via de bestaande /offertes/:id route.
 */
interface OfferteDetailDrawerState {
  openOfferteId: string | null;
  open: (id: string) => void;
  close: () => void;
}

export const useOfferteDetailDrawerStore = create<OfferteDetailDrawerState>((set) => ({
  openOfferteId: null,
  open: (id) => set({ openOfferteId: id }),
  close: () => set({ openOfferteId: null }),
}));
